export default __webpack_public_path__ + "images/pages/quiz/categories/desktop_body-6ad1e339e6554a736cb5936574764049.svg";